'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Configure2FAFreemiumResponse(results) {
  this.Lg = null;
  this.Lg = results;
}
export { $c_Lpresto_types$Configure2FAFreemiumResponse as $c_Lpresto_types$Configure2FAFreemiumResponse };
$p = $c_Lpresto_types$Configure2FAFreemiumResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Configure2FAFreemiumResponse;
/** @constructor */
function $h_Lpresto_types$Configure2FAFreemiumResponse() {
}
export { $h_Lpresto_types$Configure2FAFreemiumResponse as $h_Lpresto_types$Configure2FAFreemiumResponse };
$h_Lpresto_types$Configure2FAFreemiumResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Configure2FAFreemiumResponse)) {
    var x = this.Lg;
    var x$2 = x$0.Lg;
    return ((x === null) ? (x$2 === null) : x.i(x$2));
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "Configure2FAFreemiumResponse";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Lg;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$Configure2FAFreemiumResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jz)));
}
export { $isArrayOf_Lpresto_types$Configure2FAFreemiumResponse as $isArrayOf_Lpresto_types$Configure2FAFreemiumResponse };
var $d_Lpresto_types$Configure2FAFreemiumResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Configure2FAFreemiumResponse, "presto.types$Configure2FAFreemiumResponse", ({
  jz: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Configure2FAFreemiumResponse as $d_Lpresto_types$Configure2FAFreemiumResponse };
//# sourceMappingURL=presto.types$-Configure2-F-A-Freemium-Response.js.map
